import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'

import MainContainer3 from '../../components/Carousel/MainContainer3'
import { useParams } from 'react-router-dom'
import BannerBienEtre from '../../components/Servicepages/BannerBienEtre'
import ServicePageBienEtre from '../../components/Servicepages/ServicePageBienEtre'


const BienEtre = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
   const { titre } = useParams();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
  
      <Header />
      <BannerBienEtre titre={titre} />

      <ServicePageBienEtre titre={titre} />
     
    
     
      <Footer />
    </motion.div>
  )
}

export default BienEtre
